export default __webpack_public_path__ + "static/logo-round-purple-86b114a1691d87f922cc826a44b7fec3.svg";